import "./Autocomplete.css";

import RcSelect from "rc-select";
import { ReactNode } from "react";

import { DropdownLightIcon } from "../../../assets";
import { SelectData } from "../../../models";
import { LoadingSpinner } from "../../general/LoadingSpinner";
import { FormLabel } from "../FormLabel";
import { useAutocomplete } from "./useAutocomplete";

export interface AutocompleteProps {
  label?: string;
  initialKey?: string | null;
  initialValue?: string | null;
  placeholder?: string;
  className?: string;
  dropdownMatchSelectWidth?: boolean;
  fontSize?: "body1" | "body2" | "body3";
  corners?: "default" | "rounded";
  size?: "default" | "lm";
  disabled?: boolean;
  clearOnSelect?: boolean;
  data: SelectData;
  onSelect: (value: string) => void;
  onChange?: (value: string) => void;
  onTypeSearch?: (value: string) => void;
  tooltip?: ReactNode;
  loading?: boolean;
  /** Key of an option that stays visible even when the search matches nothing. */
  alwaysVisibleKey?: string | number;
}

export const Autocomplete = ({
  label,
  initialKey,
  initialValue,
  placeholder = "Please search",
  className,
  dropdownMatchSelectWidth,
  data,
  fontSize = "body1",
  corners = "default",
  size = "default",
  disabled,
  clearOnSelect = false,
  onChange,
  onSelect,
  onTypeSearch,
  tooltip,
  loading,
  alwaysVisibleKey,
}: AutocompleteProps): JSX.Element => {
  const { currentValue, currentKey, handleSearch, handleSelect, options } = useAutocomplete({
    data,
    initialKey,
    initialValue,
    onSelect,
    onChange,
    onTypeSearch,
    clearOnSelect,
    alwaysVisibleKey,
  });

  return (
    <FormLabel label={label} tooltip={tooltip} tooltipJustify="left">
      <div className={`${className || ""} form_field ${fontSize} ${corners} ${size}`}>
        <RcSelect
          mode="combobox"
          showSearch
          defaultValue={(data?.find((el) => el.key === currentKey)?.value ?? initialValue)?.toString()}
          value={currentValue}
          placeholder={placeholder || undefined}
          suffixIcon={loading ? <LoadingSpinner type="blue" /> : <DropdownLightIcon />}
          prefixCls="Autocomplete"
          filterOption={false}
          onSearch={handleSearch}
          onSelect={handleSelect}
          notFoundContent={null}
          dropdownMatchSelectWidth={dropdownMatchSelectWidth}
          dropdownClassName={corners === "rounded" ? "Autocomplete-dropdown-rounded" : undefined}
          disabled={disabled}
        >
          {options}
        </RcSelect>
      </div>
    </FormLabel>
  );
};
